export const selectTokenData = ($) => $?.stockManagement?.auth?.tokenData ?? null;
